import { Injectable, NgZone } from "@angular/core";
import { PlatformService } from "@obg/ngx.global.evo";

@Injectable({
	providedIn: "root",
})
export class AsyncUtils {
	constructor(
		private zone: NgZone,
		private platformService: PlatformService
	) {}

	timeoutOutsideAngular(callback: () => void, timeout: number | undefined): number | undefined {
		let timeoutRef;

		timeout = this.platformService.isServer ? 0 : timeout ?? 0;
		this.zone.runOutsideAngular(() => {
			timeoutRef = setTimeout(callback, timeout);
		});

		return timeoutRef;
	}
}
